module.exports = __webpack_public_path__ + "img/GoodIcon.c5f370c2.svg";